// This function allow to reference async chunks
__webpack_require__.k = (chunkId) => ("js/" + chunkId + ".css");